import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Gikam from 'gikam';
var defaultOptions = {};
export var TaskManager = /*#__PURE__*/function () {
  function TaskManager() {
    _classCallCheck(this, TaskManager);
  }

  _createClass(TaskManager, null, [{
    key: "openTaskManager",
    value: function openTaskManager(options) {
      this.createModel(options);
    }
  }, {
    key: "createModel",
    value: function createModel(props) {
      var h = this.$createElement;
      var options = Gikam.deepExtend(props, defaultOptions);

      var _this = this;

      this.model = new Vue({
        el: Gikam.createDom('div', document.body),
        components: {
          TaskManagerView: function TaskManagerView() {
            return import('./vue/task-manager');
          }
        },
        render: function render() {
          var h = arguments[0];
          return h("TaskManagerView", {
            "attrs": {
              "options": options
            },
            "on": {
              "afterClose": _this.afterCloseHandle.bind(_this)
            }
          });
        }
      });
    }
  }, {
    key: "afterCloseHandle",
    value: function afterCloseHandle() {
      this.model.$destroy();
      this.model = null;
    }
  }]);

  return TaskManager;
}();

_defineProperty(TaskManager, "model", null);